import { GenexSISModel } from "@/models/sis/GenexSISModel";
import Campus from "@/models/sis/Campus";
import User from "@/models/sis/User";
import Media from "@/models/sis/Media";
import {normalize} from "@/utils/data";
import GenexHelperMixins from "@/mixins/GenexHelperMixins";
// import AnnouncementModel from "@/models/sis/AnnouncementModel";
// import Department from "@/models/sis/Department";
import SISAnnouncementModel from "@/models/sis/SISAnnouncementModel";

/**
 * An announcement
 * @property {number} id
 * @property {number} campus_id - The id of the campus this announcement belongs to
 * @property {number} audience_id - 1 = staff, 2 = guardian, 3 = all
 * @property {Array<Object>} models -
 * @property {string} title
 * @property {string} audience
 * @property {string} content
 * @property {string} start_date
 * @property {string} end_date
 * @property {boolean} is_pinned - whether to pin the announcement to the top of the list
 * @property {string} payment_responsibility
 * @property {string} age_human_readable
 */
export default class SISAnnouncement extends GenexSISModel {
  static entity = "SISAnnouncements";

  static fields() {
    return {
      id: this.attr(null),
      title: this.attr(null),
      content: this.attr(null),
      start_date: this.attr(null),
      end_date: this.attr(null),
      campus: this.belongsTo(Campus, "campus_id"),
      campus_id: this.attr(null),
      audience_id: this.attr(null),
      description: this.attr(null),
      is_pinned: this.attr(0),
      audience: this.attr(null),
      is_read: this.attr(0),
      is_saved: this.attr(0),
      models: this.hasMany(SISAnnouncementModel, "announcement_id"),
      creator_id: this.attr(null),
      creator: this.belongsTo(User, "creator_id"),
      created_at: this.attr(null),
      media: this.hasManyBy(Media, "media_ids"),
      media_ids: this.attr([]),
      // departments: this.belongsTo(Department, "filters.department_ids"),
      old_pinned_announcements: this.attr([]),
      archive_days: this.attr(null),
      is_archived: this.attr(null),
      remaining_days: this.attr(null),
      filters: this.attr({
        department_ids: [],
      }),
    };
  }

  static mutators() {
    return {
      filters(value) {
        if (value == null) {
          return {
            department_ids: null,
          };
        }
        return value;
      },
    };
  }
  static FetchAll(
      { page = 1, limit = 15 },
      query = {},
      relationships = [],
      user_id,
      persistBy = "insertOrUpdate"
  ) {
    return this.api().get(`/announcements`, {
      ...GenexHelperMixins.methods.DefaultSISHeadersAndBaseUrl(),
      persistBy: persistBy,
      params: {
        ...{
          page: page,
          limit: limit,
          with: relationships,
        },
        ...query,
      },
      dataTransformer: ({ data: { data } }) => {
        // return normalize(data);
        return data.map(announcement => {
          if (relationships.includes("media")) {
            if (relationships.includes("media")) {
              if (Object.prototype.hasOwnProperty.call(announcement.attributes, "media")) {
                announcement.attributes.media.map(item => {
                  Object.assign(item, item.attributes);
                  item.mediable_type = "announcements";
                  item.mediable_id = announcement.id;
                });
              }
            }
          }
          if (Object.prototype.hasOwnProperty.call(announcement.attributes, "models")) {
            announcement.attributes.models.map(item => {
              Object.assign(item, item.attributes);

              if (item.model_type !== "Global") {
                item.model_type = item.model_type.slice(item.model_type.lastIndexOf("\\") + 1);
              }
            });
            if (announcement.attributes.models.length === 0) {
              announcement.attributes.models = [
                {
                  model_id: null,
                  model_type: "Global",
                  announcement_id: announcement.id,
                },
              ];
            }
          }

          if (relationships.includes("campus")) {
            if (announcement.attributes.campus !== null) {
              Object.assign(announcement.attributes.campus, announcement.attributes.campus.attributes);
            }
          }
          if (relationships.includes("creator")) {
            if (relationships.includes("creator")) {
              if (Object.prototype.hasOwnProperty.call(announcement.attributes, "creator")) {
                if (announcement.attributes.creator !== null) {
                  Object.assign(announcement.attributes.creator, announcement.attributes.creator.attributes);
                }
              }
            }
          }

          return { ...announcement, ...announcement.attributes };
        });
      },
    });
  }

  /**
   * Returns all announcements
   * @function
   * @param {Object} pagination
   * @param {number} pagination.page - Which page to retrieve
   * @param {number} pagination.limit - How many entities to retrieve
   * @param {?Object} [query={}] - Query terms for the request
   * @param {?string} [query.date]
   * @param {number} [query.creator]
   * @param {Array.<string>} [relationships=[]] - Relationships to bring along
   * @returns {Promise<Response>}
   */

  static MarkRead(user_id, announcement_id, is_read = 1, is_saved = 0) {
    return this.api().post(
      `/announcement-user`,
      {
        user_id: user_id,
        announcement_id: announcement_id,
        is_read: is_read,
        is_saved: is_saved,
      },
      {
        ...GenexHelperMixins.methods.DefaultSISHeadersAndBaseUrl(),
        persistBy: "update",
        dataTransformer: () => {
          return { id: announcement_id, is_read: 1, is_saved: is_saved };
        },
      },
    );
  }
}
